"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _usePresentationControl = require("./usePresentationControl");
Object.keys(_usePresentationControl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _usePresentationControl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _usePresentationControl[key];
    }
  });
});